const isEditInPreview = () => {
  const queryString =
    typeof window !== 'undefined' ? window.location.search : '';
  const params = new URLSearchParams(queryString);
  const isPreview = params.get('preview') === 'true';
  return isPreview;
};

export { isEditInPreview };
